import { format, parseISO, subBusinessDays, subDays } from 'date-fns';

// isZeroDate only cares about the year being set to 0001.
// Uses getUTCFullYear to avoid local-timezone offsets turning Jan 1 year 1 into Dec 31 year 0.
export const isZeroDate = (arg?: Date | string | null) => {
  if (!arg) return true;

  const date = typeof arg === 'string' ? parseISO(arg) : arg;

  return date.getUTCFullYear() === 1;
};

export const prettyDate = (arg?: Date | string | null) => {
  if (!arg || isZeroDate(arg)) return '';

  const date = typeof arg === 'string' ? parseISO(arg) : arg;

  return format(date, 'MMM d, yyyy');
};

export const prettyTime = (arg?: Date | string | null) => {
  if (!arg || isZeroDate(arg)) return '';

  const date = typeof arg === 'string' ? parseISO(arg) : arg;

  return format(date, 'h:mm a');
};

export const prettyDateTime = (arg?: Date | string | null) => {
  if (!arg || isZeroDate(arg)) return '';

  const date = typeof arg === 'string' ? parseISO(arg) : arg;

  return format(date, "MMM d, yyyy 'at' h:mm a");
};

// The cutoff helpers below produce RFC3339 timestamps for "older than N days" API filters.
// They take `from` so callers can pin the reference point in tests; production code omits it.
// Note they run in the browser's timezone while the backend compares in UTC, so close to
// midnight the cutoff can land a day off for users far from UTC.

export const daysAgoIso = (days: number, from: Date = new Date()): string =>
  subDays(from, days).toISOString();

// Business days here means weekends only — public holidays are intentionally not considered.
export const businessDaysAgoIso = (days: number, from: Date = new Date()): string =>
  subBusinessDays(from, days).toISOString();
